import { Component, Link } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import Results from './Results'

const hasClinics = state =>
  state.triageResponse.sessionResults.clinics
    && state.triageResponse.sessionResults.clinics.length

export default class CareOptionsResult extends Component {

  state = {
    isLoading: !hasClinics(this.props.state)
  }

  async componentDidMount() {

    const {
      actions
    } = this.props

    if (hasClinics(this.props.state)) return

    try {
      console.log('before getlocations')
      console.log(actions)
      console.log('end before getlocations')
      await actions.getTriageServiceLocations()
      console.log('care options result')
      this.setState({ isLoading: false })

    } catch(e) {
      console.log(e)
    }
  }

  render() {
    return (
      <LoadingScreen isLoading={this.state.isLoading}>
        <Results {...this.props} />
      </LoadingScreen>
    )
  }
}
